import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import acorisLogo from "../Assets/images/acoris-logo.svg";
import Header from "../Components/Header";
import Layout from "../Components/Layout";

function View() {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.ACORIS);
  const TRANSLATION = t("CONTACT_ADVISOR", { returnObjects: true });

  return (
    <Layout centered>
      <div className="acoris-contact-success">
        <img
          src={acorisLogo}
          alt="Acoris Mutuelles"
          className="acoris-contact-success__logo"
        />
        <Header
          title={TRANSLATION.SUCCESS.TITLE}
          highlight={TRANSLATION.SUCCESS.HIGHLIGHT}
        />
      </div>
    </Layout>
  );
}

export default View;
